import Analytics from '@hh.ru/analytics-js';
import { Banner, Text } from '@hh.ru/magritte-ui';
import { ElementSpyInstance } from 'bloko/common/elementSpy';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import ElementShownAnchor from 'src/components/ElementShownAnchor';
import translation from 'src/components/translation';

const TrlKeys = {
    blokoTitle: 'search.resume.notFoundByContactTitle',
    blokoDescription: 'search.resume.notFoundByContactDescription',
    title: 'search.resume.banner.notFoundByContact.title',
    desc: 'search.resume.banner.notFoundByContact.desc',
};

const sendElementShownAnalytics = (element: HTMLElement): ElementSpyInstance => {
    return Analytics.sendHHEventElementShown(element, {
        name: 'not_found_by_contact_banner',
    });
};

const NotFoundByContactBanner: TranslatedComponent = ({ trls }) => {
    return (
        <ElementShownAnchor fn={sendElementShownAnalytics}>
            <Banner
                stretched
                visible
                showBorder
                showClose={false}
                style="accent-secondary"
                title={<Text typography="title-5-semibold">{trls[TrlKeys.title]}</Text>}
                content={<Text typography="paragraph-2-regular">{trls[TrlKeys.desc]}</Text>}
            />
        </ElementShownAnchor>
    );
};

export default translation(NotFoundByContactBanner);
